module.exports = __webpack_public_path__ + "img/avatar.0db8e33c.png";